import type { ActiveStudySite } from 'common/auth/types';

import { DeviceHandoffActionType } from './constants';
import type {
    ActivityGate,
    DeviceHandoffEvent,
    DeviceHandoffRejectionReason,
    DeviceHandoffState,
    RespondentTarget,
} from './types';

export const DeviceHandoffActions = {
    initiate(
        target: RespondentTarget,
        gate: ActivityGate,
        caregiverNames: string[],
        activeStudySite: ActiveStudySite,
        activityLocation?: string
    ): DeviceHandoffEvent {
        return {
            type: DeviceHandoffActionType.INITIATE,
            target,
            gate,
            caregiverNames,
            activeStudySite,
            activityLocation,
        };
    },

    startActivation(): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.START_ACTIVATION };
    },

    accountCreated(): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.ACCOUNT_CREATED };
    },

    activationCompleted(): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.ACTIVATION_COMPLETED };
    },

    respondentAuthenticated(): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.RESPONDENT_AUTHENTICATED };
    },

    policyAcceptanceRequired(): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.POLICY_ACCEPTANCE_REQUIRED };
    },

    policyAccepted(): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.POLICY_ACCEPTED };
    },

    rejected(reason: DeviceHandoffRejectionReason): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.REJECTED, reason };
    },

    retry(): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.RETRY };
    },

    respondentTurnEnded(): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.RESPONDENT_TURN_ENDED };
    },

    siteUserReturned(): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.SITE_USER_RETURNED };
    },

    reset(): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.RESET };
    },

    overwriteFromOtherTab(state: DeviceHandoffState): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.OVERWRITE_FROM_OTHER_TAB, state };
    },

    setRespondentActivityLocation(activityLocation: string): DeviceHandoffEvent {
        return { type: DeviceHandoffActionType.SET_RESPONDENT_ACTIVITY_LOCATION, activityLocation };
    },
};
